import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/img/icons/filter.svg'
import _imports_1 from '../../../assets/img/icons/search.svg'
import _imports_2 from '../../../assets/img/icons/add-circle.svg'


const _hoisted_1 = { class: "row gx-0 mb-30" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "filter-right d-flex align-items-center justify-content-md-end flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FilterModal = _resolveComponent("FilterModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"col-md-6\" data-v-1c52162e><div class=\"filter-left d-flex align-items-center flex-wrap\" data-v-1c52162e><button type=\"button\" class=\"btn style-two\" data-bs-toggle=\"modal\" data-bs-target=\"#filterModal\" data-v-1c52162e> Filter <img src=\"" + _imports_0 + "\" alt=\"Image\" data-v-1c52162e></button><form action=\"#\" class=\"search-area position-relative w-sm-100\" data-v-1c52162e><input type=\"text\" placeholder=\"Search On This Table\" class=\"w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-black bg-white\" data-v-1c52162e><button type=\"submit\" class=\"bg-transparent border-0 position-absolute top-0 end-0 h-100 pt-0 py-0 px-2\" data-v-1c52162e><img src=\"" + _imports_1 + "\" alt=\"Image\" data-v-1c52162e></button></form></div></div>", 1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("a", {
            href: "#",
            class: "btn style-three"
          }, " Excel ", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("a", {
            href: "#",
            class: "btn style-four"
          }, " Pdf ", -1)),
          _createVNode(_component_router_link, {
            to: "/create-product",
            class: "btn style-one"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Create " + _toDisplayString(_ctx.btnText) + " ", 1),
              _cache[0] || (_cache[0] = _createElementVNode("img", {
                src: _imports_2,
                alt: "Image"
              }, null, -1))
            ]),
            _: 1,
            __: [0]
          })
        ])
      ])
    ]),
    _createVNode(_component_FilterModal)
  ], 64))
}